if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.isInsideProductInfoDrawer = Boolean(this.closest('product-info-drawer'));
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');
        this.successIcon = this.querySelector('[data-rtd-add-to-cart-success]');
        this.completed = false;

        if (document.querySelector('cart-drawer') && !this.isInsideProductInfoDrawer)
          this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true' || this.flexChoosing) return;

        const returnFocusTarget = this.rtdReturnFocusTarget || this.submitButton;
        this.rtdReturnFocusTarget = null;

        this.handleErrorMessage();

        this.form.querySelectorAll('[data-rtd-flex-property]').forEach((input) => input.remove());
        const flexConfig = this.form.querySelector(`[data-rtd-flex-config][data-rtd-flex-variant="${this.variantIdInput.value}"]`)
          || this.form.querySelector('[data-rtd-flex-config]:not([data-rtd-flex-variant])');
        if (flexConfig) {
          this.flexChoosing = true;
          try {
            const properties = await window.RtdFlexPreferences.choose(JSON.parse(flexConfig.textContent), returnFocusTarget);
            if (!properties) return;
            Object.entries(properties).forEach(([key, value]) => {
              const input = document.createElement('input');
              input.type = 'hidden';
              input.name = `properties[${key}]`;
              input.value = value;
              input.dataset.rtdFlexProperty = '';
              this.form.append(input);
            });
          } catch {
            this.handleErrorMessage('Class preferences could not be loaded. Please refresh and try again.');
            return;
          } finally {
            this.flexChoosing = false;
          }
        }

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        } else if (this.isInsideProductInfoDrawer) {
          formData.append('sections', 'cart-icon-bubble');
          formData.append('sections_url', window.location.pathname);
        }
        config.body = formData;

        const variantId = formData.get('id');
        const quantity = parseInt(formData.get('quantity')) || 1;
        const linesUpdateDeferred = this.createCartLinesUpdateEvent(variantId, quantity);

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            const productInfoDrawers = Array.from(document.querySelectorAll('product-info-drawer'));
            const targetDrawerSectionId = this.dataset.productInfoDrawerTarget;
            const productInfoDrawer = targetDrawerSectionId
              ? productInfoDrawers.find((drawer) => drawer.dataset.sectionId === targetDrawerSectionId)
              : productInfoDrawers.find((drawer) => drawer.dataset.hasContent === 'true');
            const opensProductInfoDrawer =
              this.hasAttribute('data-product-info-drawer-after-add') &&
              productInfoDrawer?.dataset.hasContent === 'true';

            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: variantId,
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
              this.dispatchCartErrorEvent(response.description || response.message, 'INVALID');
              linesUpdateDeferred?.reject(new Error(response.description || response.message));

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              this.resolveCartLinesUpdate(linesUpdateDeferred);
              if (this.isInsideProductInfoDrawer) {
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: 'product-form',
                  productVariantId: variantId,
                  cartData: response,
                });
                this.updateCartIconBubble(response);
                this.showCompletedState();
                return;
              }
              if (opensProductInfoDrawer) {
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: 'product-form',
                  productVariantId: variantId,
                  cartData: response,
                });
                this.openProductInfoDrawer(productInfoDrawer, variantId, returnFocusTarget);
                return;
              }
              window.location = window.routes.cart_url;
              return;
            }

            this.resolveCartLinesUpdate(linesUpdateDeferred);

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: variantId,
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (this.isInsideProductInfoDrawer) {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response, { open: false });
              });
              this.showCompletedState();
            } else if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response, { open: !opensProductInfoDrawer });
              });
              if (opensProductInfoDrawer) {
                this.openProductInfoDrawer(productInfoDrawer, variantId, returnFocusTarget);
              }
            }
          })
          .catch((e) => {
            console.error(e);
            this.dispatchCartErrorEvent(e.message || 'Network error', 'SERVICE_UNAVAILABLE');
            linesUpdateDeferred?.reject(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error && !this.completed) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      showCompletedState() {
        this.completed = true;
        this.submitButtonText.classList.add('hidden');
        this.successIcon?.classList.remove('hidden');
        this.submitButton.setAttribute('aria-disabled', 'true');
        this.submitButton.setAttribute(
          'aria-label',
          this.successIcon?.dataset.successLabel || 'Added to cart',
        );
      }

      updateCartIconBubble(response) {
        const cartIconBubble = document.getElementById('cart-icon-bubble');
        const sectionHtml = response.sections?.['cart-icon-bubble'];
        if (!cartIconBubble || !sectionHtml) return;

        const renderedSection = new DOMParser().parseFromString(sectionHtml, 'text/html').querySelector('.shopify-section');
        if (renderedSection) cartIconBubble.innerHTML = renderedSection.innerHTML;
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      openProductInfoDrawer(drawer, variantId, trigger = this.submitButton) {
        this.dispatchEvent(
          new CustomEvent('rtd:product-info-drawer:open', {
            bubbles: true,
            detail: {
              sectionId: drawer.dataset.sectionId,
              trigger,
              variantId,
            },
          })
        );
      }

      createCartLinesUpdateEvent(variantId, quantity) {
        const { CartLinesUpdateEvent } = window.StandardEvents || {};
        if (!CartLinesUpdateEvent) return null;

        const deferred = CartLinesUpdateEvent.createPromise();
        this.dispatchEvent(
          new CartLinesUpdateEvent({
            action: 'add',
            context: 'product',
            lines: [{ merchandiseId: variantId, quantity }],
            promise: deferred.promise,
          })
        );
        return deferred;
      }

      resolveCartLinesUpdate(deferred) {
        if (!deferred) return;
        const { CartLinesUpdateEvent } = window.StandardEvents || {};
        if (!CartLinesUpdateEvent) return;

        const pendingCartDataPromise = typeof CartItems !== 'undefined'
          ? CartItems.fetchCartData()
          : fetch(`${routes.cart_url}.json`).then((response) => response.json());

        pendingCartDataPromise
          .then((cart) => {
            if (!cart?.currency) return deferred.reject(new Error('Missing currency in cart response'));
            deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart) });
          })
          .catch((e) => deferred.reject(e));
      }

      dispatchCartErrorEvent(message, code) {
        const { CartErrorEvent } = window.StandardEvents || {};
        if (!CartErrorEvent) return;
        this.dispatchEvent(new CartErrorEvent({ error: message, code }));
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
